import React from "react";

import {
  Box,
  IconButton,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
  useMediaQuery,
  useTheme,
  Tooltip,
} from "@mui/material";
import ReplyIcon from "@mui/icons-material/Reply";
import { useNavigate, useParams } from "react-router-dom";

export function SidebarContent({ sidebarContent }: any) {
  const navigate = useNavigate();
  const { id: episodeId } = useParams();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <List
      component="nav"
      sx={{
        height: "100%",
        backgroundColor: "#fff",
      }}
    >
      <Box>
        {/* Desktop navigation buttons */}
        {!isMobile && (
          <IconButton
            edge="start"
            color="inherit"
            aria-label="open drawer"
            onClick={() => navigate(`/episodes/${episodeId}/videos`)}
            sx={{
              color: "#1976d2",
              backgroundColor: "#f5f7fa",
              border: "1px solid #e9ecef",
              width: 40,
              height: 40,
              ml: 2,
              mt: 1,
              mb: 6,
              "&:hover": {
                backgroundColor: "#e3f2fd",
                color: "#1565c0",
              },
            }}
          >
            <ReplyIcon />
          </IconButton>
        )}
        {sidebarContent.map((item: any) => {
          return (
            <Box key={item.name}>
              {item.disabled ? (
                <Tooltip
                  title="Coming Soon"
                  placement="right"
                  arrow
                  sx={{
                    "& .MuiTooltip-tooltip": {
                      backgroundColor: "#1976d2",
                      color: "#fff",
                      fontSize: "0.875rem",
                      fontWeight: 600,
                      boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                    },
                    "& .MuiTooltip-arrow": {
                      color: "#1976d2",
                    },
                  }}
                >
                  <Box>
                    <ListItemButton
                      disabled={item.disabled}
                      sx={{
                        px: 1,
                        paddingBottom: "12px",
                        paddingTop: "12px",
                        backgroundColor: item.isSelected
                          ? () => theme.palette.grey[100]
                          : "",
                        "&:hover": {
                          backgroundColor: () => theme.palette.grey[50],
                          borderRadius: "8px",
                        },
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyItems: "center",
                        cursor: "not-allowed",
                      }}
                    >
                      <ListItemIcon>{item.icon}</ListItemIcon>
                      <ListItemText>
                        <Typography sx={{ fontSize: "10px" }}>
                          {item.name}
                        </Typography>
                      </ListItemText>
                    </ListItemButton>
                  </Box>
                </Tooltip>
              ) : (
                <ListItemButton
                  sx={{
                    px: 1,
                    paddingBottom: "12px",
                    paddingTop: "12px",
                    backgroundColor: item.isSelected
                      ? () => theme.palette.grey[100]
                      : "",
                    "&:hover": {
                      backgroundColor: () => theme.palette.grey[50],
                      borderRadius: "8px",
                    },
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyItems: "center",
                    cursor: "pointer",
                  }}
                >
                  <ListItemIcon>{item.icon}</ListItemIcon>
                  <ListItemText>
                    <Typography sx={{ fontSize: "10px" }}>
                      {item.name}
                    </Typography>
                  </ListItemText>
                </ListItemButton>
              )}
            </Box>
          );
        })}
      </Box>
    </List>
  );
}
